export class ContractPartnerByGuid {
  recordId?: number;
  relatedContractPartner?: number;
  contractPartnerName?: string;
  relatedOsp?: number;
 
  constructor(data: any) {
    this.recordId = data[3]?.value;
    this.relatedContractPartner = data[13]?.value;
    this.contractPartnerName = data[11]?.value;
    this.relatedOsp = data[6]?.value;
  }
}
